/**
 * useIsSuperAdmin Hook - Simple superadmin check
 * Returns true if the current user is a superadmin
 */

import { useState, useEffect, useCallback } from 'react';
import { auth } from '../services/api/client';

export function useIsSuperAdmin() {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const checkSuperAdmin = useCallback(async () => {
    // Skip API calls if not authenticated or token is expired
    if (!auth.isAuthenticated() || !auth.isTokenValidClientSide()) {
      setLoading(false);
      setIsSuperAdmin(false);
      return;
    }
    try {
      setLoading(true);
      const userData = await auth.me();
      setUser(userData);

      const isSuper = userData?.is_superuser === true ||
                      userData?.role === 'super_admin' ||
                      userData?.subscription_plan === 'superadmin' ||
                      userData?.subscription_plan === 'sur_mesure';

      setIsSuperAdmin(isSuper);
    } catch (err) {
      // Silently handle 401 errors - user will be redirected to login by API client
      if (err.response?.status !== 401) {
        console.error('Failed to check superadmin status:', err);
      }
      setIsSuperAdmin(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkSuperAdmin();
  }, [checkSuperAdmin]);

  return {
    isSuperAdmin,
    loading,
    user,
    refresh: checkSuperAdmin
  };
}

export default useIsSuperAdmin;
